import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback } from 'recoil'

import styled from '@emotion/styled'

import {
  Breadcrumbs,
  Flex,
  LINK_VARIANT_DEFAULT,
  Link,
  TITLE_VARIANT_XL,
  Title,
} from 'mailup-web-components'

import IconChevronsRight from 'Components/icons/IconChevronsRight'

import {
  panelEditContactsBackCallback,
  panelEditContactsCloseCallback,
} from 'Pages/RecipientsList/recoil/callbacks/editContacts'

const StyledBreadcrumb: any = styled(Breadcrumbs)`
  margin: 0;
  padding: 0;
`

const PanelEditContactsHeader: FC = () => {
  const intl = useIntl()

  const handleClose = useRecoilCallback(panelEditContactsCloseCallback, [])
  const handleBack = useRecoilCallback(panelEditContactsBackCallback, [])

  const breadcrumb = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsListDetails' }),
      'data-mu-test': 'recipients-list__details',
      url: '#',
      onClick: handleBack,
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.RecipientsListEditContacts',
      }),
      'data-mu-test': 'recipients-list__details',
    },
  ]

  return (
    <Flex flexDirection="column" gap="16px">
      <Flex alignItems="center" height="20.5px">
        <Link
          variant={LINK_VARIANT_DEFAULT}
          onClick={handleClose}
          data-mu-test="close-side-panel"
          data-tip={intl.formatMessage({
            id: 'Load.RecipientsList.PanelCloseTooltip',
          })}
        >
          <IconChevronsRight width="14px" height="14px" />
        </Link>
      </Flex>

      <StyledBreadcrumb items={breadcrumb} />

      <Title variant={TITLE_VARIANT_XL} overflowWrap="anywhere">
        {intl.formatMessage({ id: 'Load.NavMenu.RecipientsListEditContacts' })}
      </Title>
    </Flex>
  )
}

export default PanelEditContactsHeader
